import React, { useState, useEffect } from 'react';
import api from '../api/axios';

export default function WhatsAppForms() {
  const [forms, setForms] = useState([]);
  const [view, setView] = useState('list'); // list | create
  const [name, setName] = useState('');
  const [category, setCategory] = useState('LEAD_GENERATION');
  const [template, setTemplate] = useState('collect_purchase_interest');
  const [businessType, setBusinessType] = useState('general');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [triggers, setTriggers] = useState({});
  const [testPhone, setTestPhone] = useState('');
  const [testFlowId, setTestFlowId] = useState(null);
  const [testLoading, setTestLoading] = useState(false);
  const [testMsg, setTestMsg] = useState('');
  const bizId = parseInt(JSON.parse(localStorage.getItem('vflow_user') || '{}')?.business_id || '0');
  useEffect(() => {
    if (bizId === 14) {
      api.get('/automation/lead-buttons').then(r => {
        if (r.data.buttons && r.data.buttons.length > 0) setLeadButtons(r.data.buttons);
        if (r.data.trigger_keywords) setLeadTriggerKeyword(r.data.trigger_keywords);
        if (r.data.welcome_message) setLeadWelcomeMsg(r.data.welcome_message);
      }).catch(() => {});
    }
  }, [bizId]);
  const [leadButtons, setLeadButtons] = useState([
    { id: 1, text: 'Agent Order', action: 'lead', status: 'hot' },
    { id: 2, text: 'Website Order', action: 'url', url: '' }
  ]);
  const [leadTriggerKeyword, setLeadTriggerKeyword] = useState('hi');
  const [leadWelcomeMsg, setLeadWelcomeMsg] = useState('Hi {1}! How would you like to place your order?');
  const [leadBtnSaving, setLeadBtnSaving] = useState(false);
  const [leadBtnMsg, setLeadBtnMsg] = useState('');
  const saveLeadButtons = async () => {
    setLeadBtnSaving(true);
    try {
      await api.post('/automation/lead-buttons', {
        business_id: bizId,
        trigger_keywords: leadTriggerKeyword,
        welcome_message: leadWelcomeMsg,
        buttons: JSON.stringify(leadButtons)
      });
      setLeadBtnMsg('Saved successfully!');
    } catch (e) { setLeadBtnMsg('Failed: ' + e.message); }
    setLeadBtnSaving(false);
  };


  const businessTypes = [
    { id: 'general', label: 'General' },
    { id: 'honey', label: 'Honey / Food Shop' },
    { id: 'restaurant', label: 'Restaurant' },
    { id: 'salon', label: 'Salon / Spa' },
  ];
  const categories = [
    { id: 'LEAD_GENERATION', label: 'Lead Generation' },
    { id: 'APPOINTMENT_BOOKING', label: 'Appointment Booking' },
    { id: 'CUSTOMER_SUPPORT', label: 'Customer Support' },
    { id: 'SURVEY', label: 'Survey' },
    { id: 'OTHER', label: 'Other' }
  ];

  const templates = [
    { id: 'collect_purchase_interest', label: 'Collect Purchase Interest' },
    { id: 'get_feedback', label: 'Get Feedback' },
    { id: 'send_a_survey', label: 'Send a Survey' },
    { id: 'customer_support', label: 'Customer Support' },
    { id: 'default', label: 'Default' }
  ];

  useEffect(() => { fetchForms(); }, []);

  const fetchForms = async () => {
    try {
      const r = await api.get('/forms/list');
      setForms(r.data.forms || []);
    } catch {}
  };

  const createForm = async () => {
    if (!name) { setMsg('Please enter a name'); return; }
    setLoading(true);
    try {
      await api.post('/forms/create', { name, category, template, business_type: businessType });
      setMsg('✅ Form created successfully!');
      setView('list');
      fetchForms();
    } catch(e) {
      setMsg('❌ ' + (e.response?.data?.error || 'Failed'));
    }
    setLoading(false);
  };


  const publishForm = async (flowId) => {
    try {
      await api.post('/forms/publish', { flow_id: flowId });
      fetchForms();
    } catch(e) {
      alert('Publish failed: ' + (e.response?.data?.error || e.message));
    }
  };

  const toggleTrigger = async (flowId, current) => {
    try {
      await api.post('/forms/trigger', { flow_id: flowId, enabled: !current });
      setTriggers(prev => ({ ...prev, [flowId]: !current }));
    } catch(e) {
      alert('Failed: ' + (e.response?.data?.error || e.message));
    }
  };
  const sendTest = async () => {
    if (!testPhone.trim()) { setTestMsg('❌ Phone number enter பண்ணுங்க'); return; }
    setTestLoading(true);
    setTestMsg('');
    try {
      await api.post('/forms/send-test', { flow_id: testFlowId, phone: testPhone.trim() });
      setTestMsg('✅ Test message sent! WhatsApp check பண்ணுங்க');
    } catch(e) {
      setTestMsg('❌ ' + (e.response?.data?.error || 'Failed to send'));
    }
    setTestLoading(false);
  };

  const S = {
    container: { padding: '24px', maxWidth: 1100, margin: '0 auto' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 },
    title: { fontSize: 22, fontWeight: 700, color: '#1a1a1a' },
    btn: { padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 600 },
    card: { background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
    row: { display: 'flex', gap: 24 },
    formLeft: { flex: 1 },
    formRight: { width: 300, background: '#f9f9f9', borderRadius: 12, padding: 16 },
    label: { fontSize: 13, fontWeight: 600, color: '#444', display: 'block', marginBottom: 6 },
    input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, marginBottom: 16 },
    select: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, marginBottom: 16 },
    radioGroup: { display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 },
    radio: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, border: '1px solid #ddd', cursor: 'pointer', background: '#fff' },
    radioActive: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, border: '1.5px solid #25D366', cursor: 'pointer', background: '#f0fdf4' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: '10px 14px', textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#666', borderBottom: '1px solid #eee' },
    td: { padding: '12px 14px', fontSize: 13, borderBottom: '1px solid #f5f5f5' },
    badge: { padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 },
    preview: { background: '#e5ddd5', borderRadius: 12, padding: 12, minHeight: 300 },
    phone: { background: '#fff', borderRadius: 10, padding: 14, fontSize: 13 }
  };

  const PreviewForm = () => (
    <div style={S.preview}>
      <div style={{ background: '#075e54', borderRadius: '10px 10px 0 0', padding: '8px 12px', marginBottom: 8 }}>
        <span style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>WhatsApp Form Preview</span>
      </div>
      <div style={S.phone}>
        <div style={{ fontWeight: 700, marginBottom: 8, fontSize: 14 }}>{name || 'Form Name'}</div>
        <div style={{ color: '#666', fontSize: 12, marginBottom: 12 }}>
          {template === 'collect_purchase_interest' && 'Collect customer product interest'}
          {template === 'get_feedback' && 'Get customer feedback'}
          {template === 'send_a_survey' && 'Send a survey to customers'}
          {template === 'customer_support' && 'Customer support form'}
          {template === 'default' && 'Default form'}
        </div>
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 12px', marginBottom: 8, fontSize: 12 }}>📝 Name</div>
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 12px', marginBottom: 8, fontSize: 12 }}>📞 Phone</div>
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 12px', marginBottom: 8, fontSize: 12 }}>🛍️ Product Interest</div>
        <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 12px', marginBottom: 8, fontSize: 12 }}>📍 City</div>
        <button style={{ width: '100%', background: '#25D366', border: 'none', color: '#fff', padding: '8px', borderRadius: 8, fontSize: 13, fontWeight: 600 }}>Submit</button>
      </div>
    </div>
  );

  return (
    <div style={S.container}>
      <div style={S.header}>
        <div>
          <div style={S.title}>WhatsApp Forms</div>
          <div style={{ fontSize: 13, color: '#888' }}>Transform leads via interactive WhatsApp Forms</div>
        </div>
        {view === 'list' && (
          <button style={{ ...S.btn, background: '#25D366', color: '#fff' }} onClick={() => { setView('create'); setMsg(''); }}>
            + Create New Form
          </button>
        )}
      </div>

      {view === 'create' && (
        <div style={S.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
            <span style={{ fontSize: 16, fontWeight: 700 }}>Create WhatsApp Form</span>
            <div style={{ display: 'flex', gap: 10 }}>
              <button style={{ ...S.btn, background: '#f5f5f5', color: '#333' }} onClick={() => setView('list')}>Cancel</button>
              <button style={{ ...S.btn, background: '#25D366', color: '#fff' }} onClick={createForm} disabled={loading}>
                {loading ? 'Creating...' : 'Save as Draft'}
              </button>
            </div>
          </div>
          {msg && <div style={{ padding: '10px 14px', background: msg.includes('✅') ? '#f0fdf4' : '#fef2f2', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{msg}</div>}
          <div style={S.row}>
            <div style={S.formLeft}>
              <label style={S.label}>Name</label>
              <input style={S.input} placeholder="Enter form name (max 20 chars)" maxLength={20} value={name} onChange={e => setName(e.target.value)} />
              <label style={S.label}>Categories</label>
              <select style={S.select} value={category} onChange={e => setCategory(e.target.value)}>
                {categories.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
              </select>
              
              <label style={S.label}>Business Type</label>
              <select style={S.select} value={businessType} onChange={e => setBusinessType(e.target.value)}>
                {businessTypes.map(b => <option key={b.id} value={b.id}>{b.label}</option>)}
              </select>
<label style={S.label}>Templates</label>
              <div style={S.radioGroup}>
                {templates.map(t => (
                  <div key={t.id} style={template === t.id ? S.radioActive : S.radio} onClick={() => setTemplate(t.id)}>
                    <div style={{ width: 16, height: 16, borderRadius: '50%', border: template === t.id ? '5px solid #25D366' : '2px solid #ddd', flexShrink: 0 }} />
                    <span style={{ fontSize: 13 }}>{t.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={S.formRight}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Preview</div>
              <PreviewForm />
            </div>
          </div>
        </div>
      )}

      {bizId === 14 && view === 'list' && (
        <div style={{ ...S.card, marginBottom: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>Lead Capture Buttons</div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Trigger Keywords (comma separated)</label>
            <input value={leadTriggerKeyword} onChange={e => setLeadTriggerKeyword(e.target.value)}
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: 8, marginTop: 4, fontSize: 13 }}
              placeholder="hi, hello, start" />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Welcome Message</label>
            <textarea value={leadWelcomeMsg} onChange={e => setLeadWelcomeMsg(e.target.value)}
              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: 8, marginTop: 4, fontSize: 13, height: 70 }} />
          </div>
          <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 13 }}>Buttons</div>
          {leadButtons.map((btn, i) => (
            <div key={btn.id} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center', background: '#f9f9f9', padding: 8, borderRadius: 8 }}>
              <input value={btn.text} onChange={e => { const b = [...leadButtons]; b[i].text = e.target.value; setLeadButtons(b); }}
                style={{ flex: 2, padding: '6px 8px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13 }}
                placeholder="Button text" />
              <select value={btn.action} onChange={e => { const b = [...leadButtons]; b[i].action = e.target.value; setLeadButtons(b); }}
                style={{ flex: 1, padding: '6px 8px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13 }}>
                <option value="lead">Lead Create</option>
                <option value="url">Open URL</option>
                <option value="reply">Reply Text</option>
              </select>
              {btn.action === 'url' && (
                <input value={btn.url || ''} onChange={e => { const b = [...leadButtons]; b[i].url = e.target.value; setLeadButtons(b); }}
                  style={{ flex: 2, padding: '6px 8px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13 }}
                  placeholder="https://..." />
              )}
              <button onClick={() => setLeadButtons(leadButtons.filter((_, j) => j !== i))}
                style={{ background: '#fef2f2', color: '#dc2626', border: 'none', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}>Remove</button>
            </div>
          ))}
          {leadButtons.length < 3 && (
            <button onClick={() => setLeadButtons([...leadButtons, { id: Date.now(), text: '', action: 'lead', status: 'hot' }])}
              style={{ background: '#f0fdf4', color: '#16a34a', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, marginBottom: 16, cursor: 'pointer' }}>+ Add Button</button>
          )}
          {leadBtnMsg && <div style={{ color: '#16a34a', fontSize: 13, marginBottom: 8 }}>{leadBtnMsg}</div>}
          <button onClick={saveLeadButtons} disabled={leadBtnSaving}
            style={{ background: '#25D366', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
            {leadBtnSaving ? 'Saving...' : 'Save Lead Buttons'}
          </button>
        </div>
      )}

      {view === 'list' && (
        <div style={S.card}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Form Name</th>
                <th style={S.th}>Category</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Responses</th>
                <th style={S.th}>Auto Trigger</th>
                <th style={S.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {forms.length === 0 && (
                <tr><td colSpan={5} style={{ ...S.td, textAlign: 'center', color: '#888' }}>No forms yet — Create one!</td></tr>
              )}
              {forms.map(f => (
                <tr key={f.id}>
                  <td style={S.td}>{f.name}</td>
                  <td style={S.td}>{f.categories?.[0] || '-'}</td>
                  <td style={S.td}>
                    <span style={{ ...S.badge, background: f.status === 'PUBLISHED' ? '#dcfce7' : '#fef9c3', color: f.status === 'PUBLISHED' ? '#16a34a' : '#854d0e' }}>
                      {f.status}
                    </span>
                  </td>
                  <td style={S.td}>{f.responses || 0}</td>
                  <td style={S.td}>
                    {f.status === 'PUBLISHED' ? (
                      <div
                        onClick={() => toggleTrigger(f.id, triggers[f.id])}
                        style={{
                          width: 44, height: 24, borderRadius: 12, cursor: 'pointer',
                          background: triggers[f.id] ? '#25D366' : '#ddd',
                          position: 'relative', transition: '0.3s'
                        }}
                      >
                        <div style={{
                          width: 20, height: 20, borderRadius: '50%', background: '#fff',
                          position: 'absolute', top: 2,
                          left: triggers[f.id] ? 22 : 2, transition: '0.3s'
                        }} />
                      </div>
                    ) : <span style={{ color: '#aaa', fontSize: 12 }}>Publish first</span>}
                  </td>
                  <td style={S.td}>
                    <button style={{ ...S.btn, background: '#f5f5f5', color: '#333', fontSize: 12 }}>Edit</button>
                    {f.status !== '' && (
                      <button style={{ ...S.btn, background: '#25D366', color: '#fff', fontSize: 12, marginLeft: 6 }} onClick={() => publishForm(f.id)}>Publish</button>
                    )}
                    <button style={{ ...S.btn, background: '#3b82f6', color: '#fff', fontSize: 12, marginLeft: 6 }} onClick={() => { setTestFlowId(f.id); setTestPhone(''); setTestMsg(''); }}>📤 Test</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Test Send Modal */}
      {testFlowId && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:16, padding:28, width:380, boxShadow:'0 8px 32px rgba(0,0,0,0.2)' }}>
            <div style={{ fontSize:16, fontWeight:700, marginBottom:16 }}>📤 Test Form Send</div>
            <div style={{ fontSize:13, color:'#666', marginBottom:16 }}>Single contact-க்கு form அனுப்பி test பண்ணலாம்</div>
            <label style={S.label}>Phone Number (with country code)</label>
            <input
              style={S.input}
              placeholder="91XXXXXXXXXX"
              value={testPhone}
              onChange={e => setTestPhone(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && sendTest()}
            />
            {testMsg && (
              <div style={{ padding:'10px 14px', background: testMsg.includes('✅') ? '#f0fdf4' : '#fef2f2', borderRadius:8, marginBottom:16, fontSize:13 }}>
                {testMsg}
              </div>
            )}
            <div style={{ display:'flex', gap:10 }}>
              <button style={{ ...S.btn, flex:1, background:'#f5f5f5', color:'#333' }} onClick={() => { setTestFlowId(null); setTestMsg(''); }}>Cancel</button>
              <button style={{ ...S.btn, flex:1, background:'#25D366', color:'#fff' }} onClick={sendTest} disabled={testLoading}>
                {testLoading ? 'Sending...' : '📤 Send Test'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
